import * as z from 'zod'

export const getServerEnv = () =>
	z
		.object({
			// API User
			API_USER_EMAIL: z.string(),
			API_USER_PASS: z.string(),

			// Emailing
			EMAILING_SECRET: z.string(),

			// Notion
			NOTION_API_KEY: z.string(),
			// Postmark
			POSTMARK_API_KEY: z.string(),

			// Vercel
			VERCEL_ENV: z.string(),
			VERCEL_URL: z.string(),
			VERCEL_WEB_ANALYTICS_DISABLE_LOGS: z.string(),
		})
		.parse({
			API_USER_EMAIL: process.env.API_USER_EMAIL,
			API_USER_PASS: process.env.API_USER_PASS,
			EMAILING_SECRET: process.env.EMAILING_SECRET,

			// Notion
			NOTION_API_KEY: process.env.NOTION_API_KEY,

			// Postmark
			POSTMARK_API_KEY: process.env.POSTMARK_API_KEY,

			REVALIDATE_SECRET: process.env.REVALIDATE_SECRET,
			VERCEL_ENV: process.env.VERCEL_ENV,
			VERCEL_URL: process.env.VERCEL_URL,
			VERCEL_WEB_ANALYTICS_DISABLE_LOGS:
				process.env.VERCEL_WEB_ANALYTICS_DISABLE_LOGS,
		})

export const envClient = z
	.object({
		NEXT_PUBLIC_API_BASE_URL: z.string(),
		NEXT_PUBLIC_APP_ENV: z.enum(['preprod', 'prod', 'development']),
		NEXT_PUBLIC_FRONT_URL: z.string(),

		// Axeptio
		NEXT_PUBLIC_AXEPTIO_CLIENT_ID: z.string(),
		NEXT_PUBLIC_COCOON_API_BASE_URL: z.string(),

		// API V2 API KEY
		NEXT_PUBLIC_COCOON_API_V2_BASE_URL: z.string(),
		NEXT_PUBLIC_FIREBASE_API_KEY: z.string(),
		NEXT_PUBLIC_FIREBASE_APP_ID: z.string(),
		NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: z.string(),

		// Firebase
		NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID: z.string(),
		NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: z.string(),
		NEXT_PUBLIC_FIREBASE_PROJECT_ID: z.string(),
		NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: z.string(),

		// Frontapp
		NEXT_PUBLIC_FRONTAPP_CHATID: z.string(),

		// Google Tag Manager
		NEXT_PUBLIC_GOOGLE_TAG_MANAGER_CONTAINER_ID: z.string(),

		// Stripe
		NEXT_PUBLIC_STRIPE_PK: z.string(),

		// Twicpics
		NEXT_PUBLIC_TWICPICS_DOMAIN: z.string(),
		NEXT_PUBLIC_TWICPICS_MAX_DPR: z.coerce.number(),
		NEXT_PUBLIC_TWICPICS_PATH: z.string(),

		// Umami
		NEXT_PUBLIC_UMAMI_WEBSITE_ID: z.string(),
	})
	.parse({
		NEXT_PUBLIC_FRONT_URL: process.env.NEXT_PUBLIC_FRONT_URL,
		NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
		NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,

		// Axeptio
		NEXT_PUBLIC_AXEPTIO_CLIENT_ID: process.env.NEXT_PUBLIC_AXEPTIO_CLIENT_ID,
		NEXT_PUBLIC_COCOON_API_BASE_URL:
			process.env.NEXT_PUBLIC_COCOON_API_BASE_URL,

		// API V2 API KEY
		NEXT_PUBLIC_COCOON_API_V2_BASE_URL:
			process.env.NEXT_PUBLIC_COCOON_API_V2_BASE_URL,
		NEXT_PUBLIC_EMAILABLE_API_KEY: process.env.NEXT_PUBLIC_EMAILABLE_API_KEY,

		NEXT_PUBLIC_FACEBOOK_APPID: process.env.NEXT_PUBLIC_FACEBOOK_APPID,
		NEXT_PUBLIC_FIREBASE_API_KEY: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
		NEXT_PUBLIC_FIREBASE_APP_ID: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
		NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN:
			process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
		// Firebase
		NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID:
			process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
		NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID:
			process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
		NEXT_PUBLIC_FIREBASE_PROJECT_ID:
			process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
		NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET:
			process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,

		// Frontapp
		NEXT_PUBLIC_FRONTAPP_CHATID: process.env.NEXT_PUBLIC_FRONTAPP_CHATID,

		// GTM
		NEXT_PUBLIC_GOOGLE_TAG_MANAGER_CONTAINER_ID:
			process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_CONTAINER_ID,
		NEXT_PUBLIC_LEGACY_URL: process.env.NEXT_PUBLIC_LEGACY_URL,

		// Mixpanel
		NEXT_PUBLIC_MIXPANEL_TOKEN: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,

		NEXT_PUBLIC_REACT_SCAN: process.env.NEXT_PUBLIC_REACT_SCAN,

		// Stripe
		NEXT_PUBLIC_STRIPE_PK: process.env.NEXT_PUBLIC_STRIPE_PK,

		// Twicpics
		NEXT_PUBLIC_TWICPICS_DOMAIN: process.env.NEXT_PUBLIC_TWICPICS_DOMAIN,
		NEXT_PUBLIC_TWICPICS_MAX_DPR: process.env.NEXT_PUBLIC_TWICPICS_MAX_DPR,
		NEXT_PUBLIC_TWICPICS_PATH: process.env.NEXT_PUBLIC_TWICPICS_PATH,

		// Umami
		NEXT_PUBLIC_UMAMI_WEBSITE_ID: process.env.NEXT_PUBLIC_UMAMI_WEBSITE_ID,
	})
